import {createRule, type Maybe} from '@regle/core';
import {useTranslation} from '#imports';

export const halfHourIncrement = createRule({
    validator(value: Maybe<number>) {
        if (value == null) {
            return true;
        }

        return /^[0-9]+(\.5)?$/.test(value.toString());
    },
    message: () => {
        const {t} = useTranslation();

        return t('activity-tracker.detailed.hourly.counter.half-hour.error.message');
    },
});
